import { useState,useEffect } from "react";
import { X, Send, Users, Car, AlertCircle } from "lucide-react";
import "./modal_newsletter.css";

export default function NewsletterCreateModal({
  open,
  onClose,
  onSubmit,
  loading,
}) {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  

  useEffect(() => {
  if (open) {
    setTitle("");
    setMessage("");
    setSelectedRoles([]);
  }
}, [open]);
if (!open) return null;

  const rolesOptions = [
    { id: "R02", label: "Clients", icon: <Users size={16} /> },
    { id: "R03", label: "Chauffeurs", icon: <Car size={16} /> },
  ];

  const toggleRole = (id) => {
    setSelectedRoles((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedRoles.length === 0) return;
    onSubmit({
      title: title.trim(),
      message: message.trim(),
      roles: selectedRoles,
    });
  };

  const handleClose = () => {
    setTitle("");
    setMessage("");
    setSelectedRoles([]);
    onClose();
  };

  const canSubmit = title.trim() && message.trim() && selectedRoles.length > 0;

  return (
    <div className="modalOverlay-Modern" onClick={handleClose}>
      <div className="modalCard-Modern" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader-Modern">
          <h3>Nouvelle Diffusion</h3>
          <button className="modalCloseModern" onClick={handleClose}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modalForm-Modern">
          <div className="formGroup-Modern">
            <label className="formLabel-Modern">Cibles (Destinataires)</label>
            <div className="roleChipsContainer-Modern">
              {rolesOptions.map((role) => (
                <div
                  key={role.id}
                  className={`roleChip-Modern ${selectedRoles.includes(role.id) ? "active" : ""}`}
                  onClick={() => toggleRole(role.id)}
                >
                  {role.icon} {role.label}
                </div>
              ))}
            </div>
          </div>

          <div className="formGroup-Modern">
            <label className="formLabel-Modern">Titre de la notification</label>
            <input
              className="formInput-Modern"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Ex: Promotion de weekend"
            />
          </div>

          <div className="formGroup-Modern">
            <label className="formLabel-Modern">Message</label>
            <textarea
              className="formTextarea-Modern"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Écrivez votre message ici..."
              style={{ minHeight: "100px" }}
            ></textarea>
          </div>

          <div className="modalFooter-Modern">
            <button
              type="submit"
              className="btnModernSend"
              disabled={loading || !canSubmit}
            >
              {loading ? (
                "Envoi..."
              ) : (
                <>
                  Diffuser maintenant <Send size={16} />
                </>
              )}
            </button>
          </div>
        </form>
        <div
          className="pushPreview-Modern"
          style={{
            position: "absolute",
            right: "-270px",
            top: "60px",
            width: "240px",
            background: "#111827",
            borderRadius: "12px",
            padding: "16px",
            color: "white",
            boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
          }}
        >
          <div
            style={{ fontSize: "0.7rem", opacity: 0.5, marginBottom: "4px" }}
          >
            CHAUFFY • À L'INSTANT
          </div>
          <div style={{ fontWeight: 600, fontSize: "0.85rem" }}>
            {title || "Titre"}
          </div>
          <div style={{ fontSize: "0.8rem", opacity: 0.8 }}>
            {message || "Votre message..."}
          </div>
        </div>
      </div>
    </div>
  );
}
